<template>
  <div class="tw-w-full tw-flex tw-flex-col">
    <span class="tw-text-base tw-text-textMain tw-font-bold tw-py-3 tw-px-4">{{ $t('解决方案') }}</span>
    <div class="tw-flex tw-flex-col ">
      <b-row>
        <b-col :cols="12">
          <div class="tw-flex tw-items-center  tw-cursor-pointer tw-bg-bgMain tw-py-2 tw-pl-4" @click="handleClickAllSolution">
            <span class="tw-text-sm tw-text-textInfo">{{ $t("解决方案") }}</span>
            <b-icon icon="chevron-right" class="tw-w-3 tw-h-3 tw-ml-0.5" style="color: #333;"></b-icon>
          </div>
        </b-col>
        <b-col :cols="12" v-for="(item, index) in solutions" :key="index">
          <MobileSelectItem :item="item" @onSelect="handleToDetail" :isShowIcon="false" :isShowDesc="false" />
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import { solutionsApi } from "@/api/modules/home";
import MobileSelectItem from './components/MobileSelectItem.vue'
export default {
  name: 'SolutionMenu',
  components: {
    MobileSelectItem
  },
  data() {
    return {
      navItems: [{
        id: 1,
        name: this.$t('解决方案'),
      }],
      activeId: 1,
      listquery: {
        pageIndex: 1,
        pageSize: 8,
      },
      solutions: []
    }
  },
  mounted() {
    this.getSouList();
  },
  methods: {
    handleClickAllSolution() {
      this.$router.push('/solution')
      this.$emit('handleToDetail', null)
    },
    handleToDetail(item) {
      console.log(item);
      localStorage.setItem("detailForm", JSON.stringify(item))
      this.$emit('handleToDetail', item)
      this.$router.push(`/solution/${item.id}?id=${item.id}&isApi=false`)
    },
    handleClick(item) {

    },

    getSouList() {
      solutionsApi(this.listquery).then((res) => {
        if (res && res.data) {
          this.solutions = res.data.list || [];
        }
      });
    },

  }
}
</script>
<style lang="scss" scoped>
</style>